export const loanModuleTourSteps = [
  {
    target: 'body',
    title: "Welcome to Loan Management",
    content: "This tour will guide you through the complete loan management process, from setting up loan types to disbursing and tracking repayments. Let's get started!",
    placement: 'center'
  },
  {
    target: 'body',
    title: "Step 1: Create Loan Types",
    content: "First, navigate to 'Loan Types' from the sidebar to set up different loan products. Define interest rates, durations, fees, and requirements like guarantors or documents. This is the foundation of your loan system.",
    placement: 'center'
  },
  {
    target: 'body',
    title: "Step 2: Configure Loan Fees",
    content: "Go to 'Loan Fees' from the sidebar to set up processing fees, insurance fees, or any other charges. You can configure percentage-based or fixed amount fees that will be automatically calculated.",
    placement: 'center'
  },
  {
    target: '.tour-loan-calculator',
    title: "Step 3: Use the Loan Calculator",
    content: "Before applying for a loan, use the 'Loan Calculator' button (purple button at the top). This helps members see exactly how much they'll receive after fees and what their repayment schedule will look like.",
    placement: 'bottom'
  },
  {
    target: '.tour-add-loan',
    title: "Step 4: Create a Loan Application",
    content: "Click 'Add Loan' or 'Apply for Loan' button at the top to create a new loan application. Select the member, loan type, principal amount, and start date. The system will automatically calculate interest, fees, and total amount.",
    placement: 'bottom'
  },
  {
    target: '.tour-loan-table',
    title: "Step 5: Attach Documents (Optional)",
    content: "If the loan type requires documents, upload them during loan creation. You can attach identity documents, income proof, collateral documentation, etc.",
    placement: 'top'
  },
  {
    target: '.tour-loan-table',
    title: "Step 6: Add Guarantors (If Required)",
    content: "For loans requiring guarantors, click on a loan from the table, then click 'Request Guarantors' on the loan details page. Select members who will guarantee the loan. They'll receive notifications to approve or reject the request.",
    placement: 'top'
  },
  {
    target: '.tour-loan-table',
    title: "Step 7: Approve the Loan",
    content: "Review the loan application in the table and click the green checkmark icon to approve. You can add approval notes. The member will be notified via SMS if enabled.",
    placement: 'top'
  },
  {
    target: 'body',
    title: "Step 8: Disburse the Loan",
    content: "After approval, click on the loan to view details, then click 'Disburse Loan'. Enter the disbursement date and any notes. The loan status will change to 'ACTIVE' and the repayment schedule begins.",
    placement: 'center'
  },
  {
    target: '.tour-loan-table',
    title: "Step 9: Record Repayments",
    content: "On the loan details page, click 'Record Repayment' to log payments. You can record cash, M-Pesa, bank transfer, or deduction from savings. The loan balance updates automatically.",
    placement: 'top'
  },
  {
    target: '.tour-loan-stats',
    title: "Step 10: Monitor Loan Performance",
    content: "The statistics cards at the top show your loan portfolio health. Navigate to 'Loan Dashboard' from the sidebar to view detailed analytics, track arrears, and monitor performance.",
    placement: 'bottom'
  },
  {
    target: 'body',
    title: "Advanced Features",
    content: "Explore advanced features from the sidebar: Loan Write-Off (for bad debts), Loan Restructure (modify terms), Loan Refinance (consolidate multiple loans), and Collateral Management. Also check out Loan Approvals page for workflow management.",
    placement: 'center'
  },
  {
    target: 'body',
    title: "Download Statements",
    content: "Click on any loan from the table to view details, then click the 'Download Statement' button to get a PDF statement showing loan details, fees breakdown, and repayment history. Perfect for record-keeping!",
    placement: 'center'
  },
  {
    target: 'body',
    title: "Tour Complete!",
    content: "You're now ready to manage loans effectively! You can restart this tour anytime by clicking the 'Tour Guide' button in the bottom-right corner. For more help, check the documentation or contact support.",
    placement: 'center'
  }
];

export const quickStartSteps = [
  {
    target: 'body',
    title: "Quick Start: Create Your First Loan",
    content: "Let's create your first loan in 3 simple steps!",
    placement: 'center'
  },
  {
    target: 'body',
    title: "1. Set Up a Loan Type",
    content: "Go to Settings → Loan Types → Add Loan Type. Enter a name (e.g., 'Emergency Loan'), set interest rate (e.g., 10%), and duration (e.g., 3 months). Click 'Add Loan Type'.",
    placement: 'center'
  },
  {
    target: 'body',
    title: "2. Create the Loan",
    content: "Go to Loans → Add Loan. Select a member, choose your loan type, enter the amount (e.g., 10,000), and set the start date. Click 'Create Loan'.",
    placement: 'center'
  },
  {
    target: 'body',
    title: "3. Approve & Disburse",
    content: "Click on the loan → Click 'Approve' (green checkmark) → Click 'Disburse Loan'. That's it! The loan is now active and ready for repayments.",
    placement: 'center'
  },
  {
    target: 'body',
    title: "You're All Set!",
    content: "Congratulations! You've created your first loan. For a detailed walkthrough of all features, start the full tour guide.",
    placement: 'center'
  }
];
